<template>
  <div>
    <div class="hvh-flex column h-100 px-2 py-3" style="background-color: #f5fbfb; border: 1px solid #8ccac8">
      <div class="menu-box-title">
        <span class="font-xl" :class="{ 'nexa-black extra-bold': ind === 0, 'nexa-regular': ind }" v-for="(item, ind) in [].concat(title)" :key="ind">{{ item }}</span>
      </div>
      <div class="my-3" style="border-top: 1px solid #8ccac8" />
      <div class="grow-1 font-sm mx-3">{{ description }}</div>
      <div class="text-center">
        <slot />
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  noExport: true,
  props: ['title', 'description'],
}
</script>

<style lang="scss" scoped>
.menu-box-title {
  color: #00214d;
  text-align: center;
}
</style>